import { useEffect, useState } from 'react'
import useQueue from '@hooks/useQueue'

export default function useRandomNextItem (intrval = 5000) {
  const { current, push, clear, concat, next } = useQueue()
  const [item, setItem] = useState('')

  useEffect(() => {
    if (item && current && item !== current) {
      setItem(null)
    } else if (!item && current) {
      const randomTimeout = Math.random() * intrval | 0
      const timeoutId = setTimeout(() => {
        setItem(current)
      }, randomTimeout)

      return () => clearTimeout(timeoutId)
    } else if (item && !current) {
      setItem(current)
    }
  }, [item, current, intrval])

  return {
    item,
    next: () => {
      setItem(null)
      next()
    },
    push,
    concat,
    clear
  }
}
